import shouldForwardProp from '@styled-system/should-forward-prop'
import { Link } from 'gatsby'
import { lighten } from 'polished'
import styled from 'styled-components'
import {
  border,
  color,
  flexbox,
  layout,
  space,
  typography
} from 'styled-system'

import { fontSizes } from './Typography'

const attrsFunction = props => ({
  color: props.color || '#fff',
  fontSize: props.fontSize || [fontSizes.copy, fontSizes.copy],
  py: props.py || 3,
  px: props.px || 4,
  bg: props.bg || '#151718',
  borderRadius: props.borderRadius || 40,
  textAlign: props.textAlign || ['center', 'center', 'left'],
  justifyContent: props.justifyContent || 'flex-start',
  width: props.width || ['100%', '100%', 'auto'],
  textWrap: 'balance',
  ...props
})

const styledLinkStyles = {
  display: 'inline-flex',
  alignItems: 'center',

  cursor: 'pointer',

  fontWeight: 700,
  textDecoration: 'none',

  transition: '120ms background-color ease-out',

  zIndex: 5,

  '&:disabled': {
    pointerEvents: 'none',
    opacity: 0.5
  }
}

const dynamicBackgroundStyles = props => ({
  '&:hover': {
    backgroundColor: lighten(0.1, props.bg)
  }
})

export const StyledExternalLink = styled('a')
  .withConfig({
    shouldForwardProp
  })
  .attrs(attrsFunction)(
  styledLinkStyles,
  dynamicBackgroundStyles,
  layout,
  space,
  color,
  typography,
  border
)

export const StyledLink = styled(Link)
  .withConfig({
    shouldForwardProp
  })
  .attrs(attrsFunction)(
  styledLinkStyles,
  dynamicBackgroundStyles,
  layout,
  space,
  color,
  typography,
  border,
  flexbox
)

export const StyledLinkButton = styled('button')
  .withConfig({
    shouldForwardProp
  })
  .attrs(props => ({ type: 'button', ...attrsFunction(props) }))(
  { border: 0, fontFamily: 'inherit', lineHeight: 'inherit' },
  styledLinkStyles,
  dynamicBackgroundStyles,
  layout,
  space,
  color,
  typography,
  border,
  flexbox
)
